import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactHighcharts from 'react-highcharts'

class Gauge extends Component {
  constructor (props) {
    super(props)
    this.gaugeOptions = {
      chart: {
        type: 'solidgauge',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        spacingBottom: 0,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0
      },
      exporting: { enabled: false },
      credits: { enabled: false },
      title: null,
      pane: {
        startAngle: -90,
        endAngle: 90,
        size: '100%',
        center: ['50%', '65%'],
        background: {
          backgroundColor: '#fff',
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },
      tooltip: { enabled: false },
      yAxis: {
        min: props.min,
        max: props.max,
        stops: props.stops.map(s => [(s[0] - props.min) / (props.max - props.min), s[1]]),
        lineWidth: 0,
        minorTickInterval: 0,
        tickPositioner: function () { return [this.min, this.max] },
        tickAmount: 1,
        labels: {
          distance: -10,
          y: 12
        }
      },
      series: [{
        name: props.title,
        data: [[0]], // the first render is always zero
        dataLabels: {
          y: 35,
          animation: { duration: 1000 },
          borderWidth: 0,
          useHTML: true,
          format: `
            <div style="text-align:center">
              <span style="font-size:${props.width * 0.13}px;color:#595959">
              {y} ${props.unit}
              </span>
              <br/>
              <span style="font-size:12px;color:#595959">${props.title}</span>
            </div>
          `
        }
      }]
    }
  }

  componentDidMount () {
    this.chart = this.refs.chart.getChart()
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps (props) {
    if (this.props.data === null) return
    this.chart.series[0].points[0]
      .update([Math.floor(props.data)], true, true)
  }

  shouldComponentUpdate () { return false }

  render () {
    return (
      <div style={{ width: this.props.width }}>
        <ReactHighcharts
          config={this.gaugeOptions}
          ref='chart' />
      </div>
    )
  }
}

Gauge.propTypes = {
  width: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  unit: PropTypes.string,
  value: PropTypes.number,
  tittle: PropTypes.string,
  stops: PropTypes.array,
  backgroundColor: PropTypes.string
}

export default Gauge



// WEBPACK FOOTER //
// ./src/charts/Gauge.js